import React from 'react'
import { listOportunidades } from '@/modules/oportunidades/services/oportunidadesService'
import type { OpportunityItem } from '@/modules/oportunidades/types'

type UseConfirmedOpportunitiesForLinkResult = {
  items: OpportunityItem[]
  selected: OpportunityItem | null
  loading: boolean
  error: string | null
}

export function useConfirmedOpportunitiesForLink(
  enabled: boolean,
  selectedOpportunityId: number | null,
): UseConfirmedOpportunitiesForLinkResult {
  const [allItems, setAllItems] = React.useState<OpportunityItem[]>([])
  const [items, setItems] = React.useState<OpportunityItem[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const selected = React.useMemo(() => {
    if (!enabled) return null
    if (selectedOpportunityId == null) return null
    const targetId = Number(selectedOpportunityId)
    if (!Number.isFinite(targetId)) return null
    return allItems.find((it) => Number(it.id) === targetId) ?? null
  }, [allItems, enabled, selectedOpportunityId])

  React.useEffect(() => {
    if (!enabled) {
      setAllItems([])
      setItems([])
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    listOportunidades()
      .then((rows) => {
        if (!active) return
        setAllItems(rows || [])
        const onlyActive = (rows || []).filter(
          (it) => String(it.status || '').toLowerCase() === 'active',
        )
        const sorted = [...onlyActive].sort((a, b) => {
          const ta = a.publishedAt ? Date.parse(a.publishedAt) : 0
          const tb = b.publishedAt ? Date.parse(b.publishedAt) : 0
          return tb - ta
        })
        setItems(sorted)
      })
      .catch((e: any) => {
        if (!active) return
        setAllItems([])
        setItems([])
        setError(e?.message || 'Falha ao carregar oportunidades confirmadas')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled])

  return { items, selected, loading, error }
}
